import React from 'react'
import Box from '@mui/material/Box'
import { useMediaQuery } from '@mui/material'
import TitleWithRemark from 'components/common/TitleWithRemark'
import LinkItem from './LinkItem'

const FooterLinks = ({ title, links, bottomComponent }) => {
  const isLgUp = useMediaQuery((theme) => theme.breakpoints.up('lg'))

  return (
    <Box display="flex" flexDirection="column">
      <TitleWithRemark variant="labelLarge">{title}</TitleWithRemark>
      <Box py={isLgUp ? 5 : 4}>
        {!isLgUp ? (
          <Box
            display="flex"
            flexWrap="wrap"
            alignItems="center"
            sx={{ rowGap: '12px' }}
          >
            {links.map((link, index, array) => (
              <React.Fragment key={index}>
                <LinkItem
                  href={link.href}
                  originalLink={link.originalLink}
                  target={link.target}
                  $isFirst
                >
                  {link.text}
                </LinkItem>
                {index < array.length - 1 && (
                  <Box
                    component="span"
                    mx={3}
                    height="17px"
                    width="1px"
                    backgroundColor="#D4D4D4"
                  />
                )}
              </React.Fragment>
            ))}
            {bottomComponent}
          </Box>
        ) : (
          <>
            {links.map((link, index) => (
              <LinkItem
                key={index}
                href={link.href}
                originalLink={link.originalLink}
                target={link.target}
                $isFirst={index === 0}
              >
                {link.text}
              </LinkItem>
            ))}
            {bottomComponent}
          </>
        )}
      </Box>
    </Box>
  )
}

export default FooterLinks
